import { render } from "./Command.vue?vue&type=template&id=4dd3d626"
import script from "./Command.vue?vue&type=script&lang=js"
export * from "./Command.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__